import {DateTime} from 'luxon';
import {Valid} from 'luxon/src/_util';

export const getUTCDateTime = (): DateTime<Valid> => DateTime.now().toUTC();

export const getUTCDateTimeFromString = (
  date: string | undefined
): DateTime<Valid> => {
  if (!date) {
    throw new Error('Date not provided!');
  }
  const dateTime = DateTime.fromISO(date);
  if (!dateTime.isValid) {
    throw new Error('Invalid date format!');
  }
  return dateTime.toUTC();
};

export const getUTCDateTimeFromMillis = (
  timestamp: number
): DateTime<Valid> => {
  const dateTime = DateTime.fromMillis(timestamp);
  if (!dateTime.isValid) {
    throw new Error('Invalid date format!');
  }
  return dateTime.toUTC();
};
